import { getFullUrl } from 'hubspot-url-utils';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
const CALLING_WINDOW_NAME = 'calling-window';
export const openCallingWindow = () => {
  const portalId = PortalIdParser.get();
  const subdomainPrefix = enviro.deployed() ? 'app' : 'local';
  window.open(`${getFullUrl(subdomainPrefix)}/calling-integration-popup-ui/${portalId}`, CALLING_WINDOW_NAME, 'menubar=no,resizable=yes,scrollbars=no,location=no,width=400,height=750');
};
export const showCallingWindow = () => {
  const callingWindow = window.open('', CALLING_WINDOW_NAME);
  if (callingWindow) {
    callingWindow.focus();
  }
};